import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const DeleteConfirmDialog = ({ open, handleClose, loading, handleConfirmDelete }) => (
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="delete-dialog-title"
    aria-describedby="delete-dialog-description"
  >
    <DialogTitle id="delete-dialog-title">Confirm Termination</DialogTitle>
    <DialogContent>
      <DialogContentText id="delete-dialog-description">
        Are you sure you want to terminate this dealer? This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      <Button onClick={handleConfirmDelete} color="error" variant="contained" disabled={loading} autoFocus>
        {loading ? 'Terminating…' : 'Terminate'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmDialog;
